import { Route } from '@angular/router';
import { AdminShellComponent } from './admin-shell/admin-shell.component';
import { AuthComponent } from '@wayout-admin/auth';
import { CanActivateShellGuard } from './guards/can-activate-shell.guard';
import { CanActivateAuthGuard } from './guards/can-activate-auth.guard';

export const shellRoutes: Route[] = [
	{
		path: 'admin',
		component: AdminShellComponent,
		children: [
			{ path: 'home', loadComponent: () => import('@wayout-admin/home').then((m) => m.HomeComponent) },
			{
				path: 'destinations',
				loadComponent: () => import('@wayout-admin/destinations').then((m) => m.DestinationsComponent),
			},
			{
				path: 'last-minute',
				loadComponent: () => import('@wayout-admin/last-minute').then((m) => m.AdminLastMinuteComponent),
			},
			{
				path: 'first-minute',
				loadComponent: () => import('@wayout-admin/first-minute').then((m) => m.AdminFirstMinuteComponent),
			},
			{
				path: 'premium',
				loadComponent: () => import('@wayout-fe/admin-premium').then((m) => m.AdminPremiumComponent),
			},
			{
				path: 'special-offer',
				loadComponent: () => import('@wayout-fe/admin-special-offer').then((m) => m.AdminSpecialOfferComponent),
			},
			{
				path: 'metadata',
				loadComponent: () => import('@wayout-admin/metadata').then((m) => m.MetadataComponent),
			},
			{
				path: 'menu-destination',
				loadComponent: () => import('@wayout-admin/menu-destination').then((m) => m.MenuDestinationComponent),
			},
			{
				path: 'header-config',
				loadComponent: () => import('@wayout-fe/admin-header-config').then((m) => m.HeaderConfigComponent),
			},
			{
				path: '',
				redirectTo: 'home',
				pathMatch: 'full',
			},
		],
		canActivate: [CanActivateShellGuard],
	},
	{
		path: 'auth',
		component: AuthComponent,
		children: [
			{ path: 'login', loadComponent: () => import('@wayout-admin/auth').then((m) => m.LoginComponent) },
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full',
			},
		],
		canActivate: [CanActivateAuthGuard],
	},
	{
		path: '',
		redirectTo: '/auth',
		pathMatch: 'full',
	},
	{
		path: '**',
		redirectTo: '/auth',
		pathMatch: 'full',
	},
];
